import React from 'react';
import { Icon, IconName } from '../../atoms/icons';
import { colors } from '../../styles';

export interface Props {
  status: boolean;
}

export default class StatusIndicator extends React.Component<Props> {
  icon: IconName = this.props.status ? 'checkmarkInCircle' : 'closeCircle';
  color = this.props.status ? colors.green500 : colors.grey500;

  render() {
    return <Icon baseColor={this.color} icon={this.icon} />;
  }
}
